import { Grid, LinearProgress, Typography } from '@material-ui/core'

import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { FutureIconContainer } from 'asterX-UI/Icons'
import ShieldZapIcon from 'asterX-UI/Icons/ShieldZapIcon'
import { AutoCompleteField } from 'asterX-UI/Inputs'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import ActionModal from 'asterX-UI/Modals/ActionModal'

import { useProfileStore } from 'context/ProfileStore'
import { generateUuid } from 'lib/utils'

const getInitialValue = data => {
  if (data?.grantsState && data?.roleKey) {
    const selectState = data.grantsState?.reduce((acc, item) => {
      acc[item.key] = item.values
      return acc
    }, {})
    return {
      roleId: data?.roleId,
      roleKey: data.roleKey,
      ...selectState
    }
  }
  return { roleId: '', roleKey: '' }
}
const uuid = generateUuid()
const namespace = 'profilePage.superset.addEditAccessesModal.'

const AddEditAccessesModal = ({ open, onClose = () => {}, data = {} }) => {
  const { t } = useTranslation()
  const {
    profileStore: { superset }
  } = useProfileStore()
  const _isMounted = useRef(false)
  const isEdit = !!data?.roleId
  const [sendData, setSendData] = useState(getInitialValue(data))
  const [roleInfo, setRoleInfo] = useState([])
  const [loading, setLoading] = useState({
    init: false,
    save: false
  })

  const setLoader = (key, value) =>
    setLoading(prevState => ({ ...prevState, [key]: value }))

  useEffect(() => {
    if (!!sendData?.roleId) setLoader('init', true)

    return () => {
      _isMounted.current = false
    }
  }, [sendData.roleId])

  const onChangeRole = e => {
    const { value } = e.target

    const roleKey = superset?.roleList?.find(
      item => item.id?.toString() === value?.toString()
    )?.code

    setSendData({ roleId: value, roleKey })
  }

  const onChangeSelect = e => {
    const { name, value } = e.target
    setSendData(prev => ({ ...prev, [name]: value }))
  }
  const handleSave = async () => {
    setLoader('save', true)
  }

  const roleList =
    superset?.accessList?.length > 0
      ? superset?.roleList?.filter(
          role => !superset?.accessList.find(a => a.roleKey === role.code)
        )
      : superset?.roleList

  return (
    <ActionModal
      open={open}
      color={'primary'}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={handleSave}
      iconComponent={
        <FutureIconContainer color={'success'}>
          <ShieldZapIcon />
        </FutureIconContainer>
      }
      title={t(namespace + (isEdit ? 'titleEdit' : 'title'), {
        role: data?.roleTitle || ''
      })}
      subtitle={t(namespace + 'subtitle')}
      labelConfirm={t(namespace + 'save')}
    >
      <Grid container spacing={3}>
        <LoaderBackdrop loading={loading.save} />
        {!isEdit && (
          <Grid item xs={12} md={12} lg={12} xl={12}>
            <AutoCompleteField
              name={'roleId'}
              value={sendData.roleId}
              options={roleList}
              onChange={onChangeRole}
              valueKey={'id'}
              label={t(namespace + 'role')}
              placeholder={t(namespace + 'role')}
              fullWidth
              loading={loading.init}
              disabled={loading.init || roleList?.length === 0}
            />
          </Grid>
        )}
        {loading.init && (
          <Grid item xs={12} md={12} lg={12} xl={12}>
            <LinearProgress color={'primary'} />
          </Grid>
        )}

        {roleInfo?.length <= 0 ? (
          <Grid item>
            <Typography variant={'h5'} color={'secondary'}>
              {t(namespace + 'errors.selectRole')}
            </Typography>
          </Grid>
        ) : (
          roleInfo?.map((item, index) =>
            item?.key ? (
              <Grid
                item
                xs={12}
                md={12}
                lg={12}
                xl={12}
                key={uuid + '_' + index}
              >
                <AutoCompleteField
                  name={item?.key}
                  value={sendData?.[item?.key] || []}
                  options={item?.values}
                  onChange={onChangeSelect}
                  valueKey={'id'}
                  labelKey={'title'}
                  label={item?.title}
                  placeholder={item?.title}
                  multiple
                  fullWidth
                  disabled={
                    loading.init ||
                    item?.values?.length === 0 ||
                    (item?.values?.length === 1 && !item?.values[0]?.id)
                  }
                />
              </Grid>
            ) : (
              <Grid item>
                <Typography variant={'h5'} color={'secondary'}>
                  {t(namespace + 'errors.accessesBroken')}
                </Typography>
              </Grid>
            )
          )
        )}
      </Grid>
    </ActionModal>
  )
}

export default AddEditAccessesModal
